
import Styles from "./About.module.scss";

export const About = () => {

    return <div className={Styles.homepage}>

        <div className={Styles.gradient}>
            <div className={Styles.text}>
        Poslouchejte rádia online.<br/>
        Kdykoliv, kdekoliv
            </div>
        </div>
    </div>
}